import * as loc from "./local";
import * as ext from "./external";
export const external = {
  ...ext,
};
export const local = {
  ...loc,
};
export { default } from "./selectors";



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/selectors/index.js